import React from 'react';
import { InputGroupSimple } from '@gjensidige/core-forms';

import { useCheckListContext } from '../context/CheckListProvider';
import styles from './RadioButtons.module.scss';

interface Props {
  options: Array<{ label: string; value: string }>;
  onChange: (answer: string) => void;
}

const RadioButtons = ({ options, onChange }: Props) => {
  const { answers, currentStep } = useCheckListContext();

  return (
    <InputGroupSimple
      centered={false}
      coloredBackground={false}
      dividers={false}
      id={`input-group-radio-${currentStep}`}
      name="radio"
      options={options}
      onChange={(event) => onChange(event.target.value)}
      type="radio"
      value={answers[currentStep]}
      className={styles.radioButtons}
    />
  );
};

export default RadioButtons;
